import React from "react";
import { Box, Button, Container, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import logo from "../images/logo2.png";

export default function AppShell({ children, tab, onTabChange }) {
  const navigate = useNavigate();
  const signOut = () => {
    localStorage.removeItem("rasyueToken");
    navigate("/");
  };

  return (
    <Box minH="100dvh" display="flex" flexDirection="column" pb="calc(4.5rem + env(safe-area-inset-bottom))">
      <Box
        as="header"
        bg="white"
        borderBottomWidth="1px"
        borderColor="gray.100"
        pt="env(safe-area-inset-top)"
        position="sticky"
        top={0}
        zIndex={10}
      >
        <Container maxW="container.md" px={4} py={3}>
          <Flex align="center" justify="space-between" gap={3}>
            <Flex align="center" gap={2} minW={0}>
              <img
                src={logo}
                alt=""
                style={{ height: 36, width: "auto", objectFit: "contain", flexShrink: 0 }}
              />
              <Box minW={0}>
                <Text fontWeight="bold" fontSize="lg" lineHeight="short">WorryLess</Text>
                <Text fontSize="xs" color="gray.500" noOfLines={1}>Your week, in one place</Text>
              </Box>
            </Flex>
            <Button size="sm" variant="ghost" onClick={signOut}>Sign out</Button>
          </Flex>
        </Container>
      </Box>

      <Container as="main" maxW="container.md" px={4} py={4} flex="1" w="100%">
        {children}
      </Container>

      <Box
        as="nav"
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        bg="white"
        borderTopWidth="1px"
        borderColor="gray.200"
        pb="env(safe-area-inset-bottom)"
        zIndex={10}
      >
        <Container maxW="container.md" px={2}>
          <Flex>
            <TabButton active={tab === "list"} onClick={() => onTabChange("list")} label="Tasks" />
            <TabButton active={tab === "calendar"} onClick={() => onTabChange("calendar")} label="Calendar" />
            <TabButton active={tab === "settings"} onClick={() => onTabChange("settings")} label="Settings" />
          </Flex>
        </Container>
      </Box>
    </Box>
  );
}

function TabButton({ active, onClick, label }) {
  return (
    <Flex
      as="button"
      type="button"
      flex={1}
      py={3}
      align="center"
      justify="center"
      fontWeight={active ? "semibold" : "medium"}
      color={active ? "gray.800" : "gray.500"}
      borderTopWidth="3px"
      borderColor={active ? "gray.700" : "transparent"}
      onClick={onClick}
      _hover={{ bg: "gray.50" }}
    >
      {label}
    </Flex>
  );
}
